export default {
  page_title: 'おすすめキャンペーン',
  provider_status: 'ステータス',
  provider_key: '媒体',
  provider_tag: 'コンテンツ',
  tag_content: 'おすすめ',
  entity: 'お知らせ',
  daily_budget_error: '{providers}の１日予算値は最低値より大きくしてください。'
};
